import React, { useState, useEffect, formattedCreationDate } from 'react';
import {
  Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, MenuItem, FormControl, InputLabel, Select, IconButton, List, ListItem, ListItemText, Checkbox, LinearProgress, Typography, Grid, Box,
  Divider
} from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import { getFirestore, collection,where,query, getDocs, doc, getDoc, updateDoc, addDoc, setDoc } from 'firebase/firestore';
import { app } from './auth/firebaseConfig';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add'; // Import Add Icon
import Comments from './Comments'; // Import the Comments component
import { fetchUsersAndTenants, fetchUserIdByEmail, fetchCreatedByUserName, fetchUserNameById, fetchAssignedGroupsByEmail, fetchBoards, fetchLastSerialNumber } from '../DatabaseApis/DBQuery';
import { fetchTenantUsers } from '../DatabaseApis/DBQuery';
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { storage } from './auth/firebaseConfig';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { getAuth } from "firebase/auth";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloseIcon from '@mui/icons-material/Close'; // Add this import
import { useParams } from 'react-router-dom';
import { getCookie } from '../utils/cookieUtils';
import { saveNewCard } from "../utils/firestoreCards";

/**
 * AddCardDialog Component
 * Recent changes:
 * 1. Modified comment handling to use createdByUserName instead of email
 * 2. Improved timestamp handling for card updates
 * 3. Removed border between comments and subtasks sections
 * 4. Enhanced user information consistency
 */

// Replace the hardcoded constants with environment variables
const MAX_FILE_COUNT = parseInt(process.env.REACT_APP_MAX_FILE_COUNT) || 10;
const MAX_FILE_SIZE_MB = parseInt(process.env.REACT_APP_MAX_FILE_SIZE_MB) || 5;

const AddCardDialog = ({ open, onClose, onSave, initialData, columns, prjName, email, projectId }) => {
  const [taskName, setTaskName] = useState('');
  const [description, setDescription] = useState('');
  // const [cardStatus, setCardStatus] = useState('');
  //const [cardStatus, setCardStatus] = useState(initialData?.cardStatus || columns[0].name);
  const [cardStatus, setCardStatus] = useState(//after adding this, the functionality for editing was working
  initialData?.cardStatus ||
  (columns?.length ? columns[0].name : '')   // ✅ avoid .name when columns is empty
);
  const [assigneeName, setAssigneeName] = useState('');
  const [assigneeEmail, setAssigneeEmail] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [priority, setPriority] = useState('Low');
  const [userList, setUserList] = useState([]);
  const [subtaskName, setSubtaskName] = useState('');
  const [subtasks, setSubtasks] = useState([]);
  const [acceptanceCriteria, setAcceptanceCriteria] = useState('');
  const [estimate, setEstimate] = useState('');
  const [cardId, setCardId] = useState('');
  const [lastSerialNumber, setLastSerialNumber] = useState(0);
  const [taskNameError, setTaskNameError] = useState(false);
  const [dueDateError, setDueDateError] = useState(false);
  const [comment, setComment] = useState("");
  const [cardUpdatedByUserId, setCardUpdatedByUserId] = useState(null);
  const [cardUpdatedOn, setCardUpdatedOn] = useState(null);
  const [updatedByUserName, setUpdatedByUserName] = useState(null); // Add state to store username
  const [cardType, setCardType] = useState('');
  const [createdByUserName, setCreatedByUserName] = useState(null); // Add state to store creator's username
  const [cardCreationDateDisplay, setCardCreationDateDisplay] = useState(null); // For formatted creation date
  const [comments, setComments] = useState([]);
  const [currentUserInfo, setCurrentUserInfo] = useState(null);
  const [expandedSubtasks, setExpandedSubtasks] = useState(new Set());
  const [userName, setUserName] = useState('');
  const [userId, setUserId] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedFilesToDelete, setSelectedFilesToDelete] = useState(new Set());
  const [isDragging, setIsDragging] = useState(false);
  const defaultDueDate = new Date();
  defaultDueDate.setDate(defaultDueDate.getDate() + 5); // Add 5 days
  const [uploadProgress, setUploadProgress] = useState({});
  const [selectedBoardId, setSelectedBoardId] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [assignedGroups, setAssignedGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [boards, setBoards] = useState([]);
  const {boardId} = useParams();
  const [assignedSprints, setAssignedSprints] = useState(initialData?.assignedSprints || []);
  const [availableSprints, setAvailableSprints] = useState([]);
  const [currentBoard, setCurrentBoard] = useState(null); //checks current board


  const db = getFirestore(app);
  const userData = getCookie('userData');
  useEffect(() => {
  // Only fetch users for the current tenant to ensure tenant isolation in dropdowns.
  // This prevents users from seeing or assigning cards to users outside their tenant.
    if (open) { // Only run when the dialog is open
      const userData = getCookie('userData');
      if (userData && userData.tenantId) {
        setTenantId(userData.tenantId);
      }
    }
  }, [open]);
  useEffect(() => {
    const fetchBoardDetails = async () => {
      if (boardId && tenantId) { // Ensure tenantId is available
        try {
          const boardRef = doc(db, `tenants/${tenantId}/boards`, boardId);
          const boardSnap = await getDoc(boardRef);
          if (boardSnap.exists()) {
            setCurrentBoard({ id: boardSnap.id, ...boardSnap.data() });
          } else {
            console.log("No such board!");
            setCurrentBoard(null);
          }
        } catch (error) {
          console.error("Error fetching board details:", error);
        }
      }
    };
    fetchBoardDetails();
  }, [boardId, db, tenantId, open]);

  // Add this inside your AddCardDialog.js component
  useEffect(() => {
    if (open) {
      console.log("INITIAL DATA RECEIVED BY DIALOG:", initialData);
      console.log("SPRINTS FROM INITIAL DATA:", initialData?.assignedSprints);
    }
  }, [open, initialData]);

  useEffect(() => {
    // Only show active Sprint boards (boardActiveStatus === true)
    const activeSprints = boards.filter(
      b => b.boardType === 'Sprint' && b.boardActiveStatus === true
    );
    setAvailableSprints(activeSprints);
  }, [boards]);

  useEffect(() => {
    const getUserId = async () => {
      if (email) {
        try {
          const userData = await fetchUserIdByEmail(email);
          if (userData) {
            setUserId(userData.userId);
            setUserName(userData.userName);
            setTenantId(userData.tenantId);
            // console.log(userId, userName); // Commented out to avoid revealing user data
          }
        } catch (error) {
          console.error("Error fetching user ID:", error);
        }
      }
    };

    getUserId();
  }, [email]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        if (!tenantId) return;
        const users = await fetchTenantUsers(tenantId);
        setUserList(users);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
    fetchUsers();
  }, [db, tenantId]);

  useEffect(() => {
        const getGroups = async () => {
          if (!email) return; // Ensure userEmail is available
      
          try {
            const { userId, assignedGroups } = await fetchAssignedGroupsByEmail(email);
            setUserId(userId);
            setAssignedGroups(assignedGroups);

          } catch (error) {
            setError("Error fetching assigned groups: " + error.message);
          }
        };
      
        getGroups();
      }, [email]);

  useEffect(() => {
        const getBoardsData = async () => {
          if (!projectId || !assignedGroups || !tenantId) return;
      
          try {
            setLoading(true);
            // const boardsQuery = query(collection(db, 'boards'), where('projectId', '==', projectId));
          // const boardsSnapshot = await getDocs(boardsQuery);
          // const fetchedBoards = boardsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            const fetchedBoards = await fetchBoards(projectId, assignedGroups, tenantId);
      
            setBoards(fetchedBoards);
      
            if (fetchedBoards.length > 0) {
              // setSelectedBoardId(fetchedBoards[0].id);
              setSelectedBoardId(boardId);
              // setboardName(fetchedBoards[0].boardName);
            }
          } catch (error) {
            setError("Error fetching boards: " + error.message);
          } finally {
            setLoading(false);
          }
        };
  
        getBoardsData();
    }, [projectId, assignedGroups, tenantId]);

  useEffect(() => {
    if (initialData && open) {
      // const getCreatedByUserName = async () => {
      //   const userName = await fetchCreatedByUserName(initialData.cardCreatedByUserId);
      //   setCreatedByUserName(userName);
      // };

      if (initialData.cardCreatedByUserId) {
        fetchUserNameById(initialData.cardCreatedByUserId).then(setCreatedByUserName);
      } else {
        setCreatedByUserName('Unknown User');
        
      }

      if (initialData.cardCreationDate) {
        setCardCreationDateDisplay(initialData.cardCreationDate);
      }
      setComments(initialData.comments || []);
      
      // Set current user info
      if (email) {
        setCurrentUserInfo({
          uid: userId,
          email: email
        });
      }
      setAssigneeName(initialData.assigneeName || "");
      setAssigneeEmail(initialData.assigneeEmail || "");
    } else if (open) {
      setTaskName("");
      setCardId('');
      setDescription("");
      setCardStatus(columns && columns.length > 0 ? columns[0].name : '');
     //setCardStatus(columns && columns.length > 0 ? columns[0].name : '');
      setAssigneeName(userName);
      const user = userList.find(u => u.userName === userName);
      setAssigneeEmail(user ? user.email : '');
      setDueDate(defaultDueDate.toISOString().split("T")[0]);
      setPriority("Medium");
      setAcceptanceCriteria("");//Added this line to reset acceptance criteria
      setSubtasks([]);
      setEstimate("");
      setCardUpdatedByUserId(null);
      setCardUpdatedOn(null);
      setUpdatedByUserName(null);
      setCardType("Task"); // Reset to default card type
      setComments([]);
      // setSelectedBoardId(boardId);
      if (email) {
        setCurrentUserInfo({
          uid: userId,
          email: email
        });
      }
    }
  }, [initialData, open, email, userId, userName, userList]);


  useEffect(() => {
    if (initialData && open) {
      setTaskName(initialData.taskName || "");
      setDescription(initialData.description || "");
      setCardStatus(initialData.cardStatus || "");
      setAssigneeName(initialData.assigneeName || "");
      setDueDate(initialData.dueDate || "");
      setPriority(initialData.priority || "");
      setSubtasks(initialData.subtasks || []);
      setEstimate(initialData.estimate || "");
      // Only set cardId for existing cards, not for duplicates
      setCardId((initialData && !initialData.isDuplicate) ? (initialData.cardId || "") : "");
      setCardUpdatedByUserId(initialData.cardUpdatedByUserId || "");
      setCardUpdatedOn(initialData.cardUpdatedOn || "");
      setCardType(initialData.cardType || ""); // Reset to default card type
      setSelectedBoardId(initialData.boardId || "");

      // Fetch username corresponding to cardUpdatedByUserId
      if (initialData.cardUpdatedByUserId) {
        fetchUserNameById(initialData.cardUpdatedByUserId).then(setUpdatedByUserName);
      } else {
        setUpdatedByUserName('Unknown User');
      }
      if (initialData.files && Array.isArray(initialData.files)) {
        setUploadedFiles(initialData.files);
      }
    } else if (open) {
      setTaskName("");
      setDescription("");
      setCardStatus(columns[0].name);
      setAssigneeName(userName);
      const user = userList.find(u => u.userName === userName);
      setAssigneeEmail(user ? user.email : '');
      setDueDate(defaultDueDate.toISOString().split("T")[0]);
      setPriority("Medium");
      setSubtasks([]);
      setEstimate("");
      setCardUpdatedByUserId(null);
      setCardUpdatedOn(null);
      setUpdatedByUserName(null);
      setCardType("Task"); // Reset to default card type
      setUploadedFiles([]);
      // setSelectedBoardId(boardId);
    }
  }, [initialData, open]);

  // Fetch the last serial number when dialog opens for new cards or duplicated cards
  useEffect(() => {
    if (open && projectId && (!initialData || initialData.isDuplicate)) {
      const getLastSerialNumber = async () => {
        try {
          const serialNumber = await fetchLastSerialNumber(projectId);
          setLastSerialNumber(serialNumber);
        } catch (error) {
          console.error("Failed to fetch serial number:", error);
          setLastSerialNumber(0); // Fallback to 0 if fetch fails
        }
      };
      getLastSerialNumber();
    }
  }, [open, projectId, initialData]);

  useEffect(() => {
    const fetchUploadedFiles = async () => {
      if (!cardId) return;
  
      const cardRef = doc(db, "cards", cardId);
      const cardSnap = await getDoc(cardRef);
  
      if (cardSnap.exists()) {
        const cardData = cardSnap.data();
        if (cardData.files && Array.isArray(cardData.files)) {
          // Filter out any files that don't exist in storage
          const validFiles = await Promise.all(
            cardData.files.map(async (file) => {
              try {
                const fileRef = ref(storage, `card-images/${file.id}`);
                await getDownloadURL(fileRef);
                return file;
              } catch (error) {
                // If file doesn't exist in storage, return null
                return null;
              }
            })
          );

          // Filter out null values and update Firestore if needed
          const filteredFiles = validFiles.filter(file => file !== null);
          if (filteredFiles.length !== cardData.files.length) {
            // Some files were deleted from storage, update Firestore
            await updateDoc(cardRef, {
              files: filteredFiles,
              cardUpdatedByUserId: userId,
              cardUpdatedOn: new Date().toLocaleString("en-IN", {
                timeZone: "Asia/Kolkata",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
            });
          }

          setUploadedFiles(filteredFiles);
        }
      }
    };
  
    fetchUploadedFiles();
  }, [cardId]);


  const handleAddSubtask = () => {
    if (subtasks.length >= 10) {
      alert('You can only add up to 10 subtasks.');
      return;
    }
    if (subtaskName.trim()) {
      setSubtasks([...subtasks, { id: uuidv4(), name: subtaskName, completed: false }]);
      setSubtaskName('');
    }
  };

  const handleRemoveSubtask = (subtaskId) => {
    setSubtasks(subtasks.filter((subtask) => subtask.id !== subtaskId));
  };

  const handleSubtaskCompletion = (subtaskId) => {
    setSubtasks(
      subtasks.map((subtask) =>
        subtask.id === subtaskId ? { ...subtask, completed: !subtask.completed } : subtask
      )
    );
  };

  const calculateCompletionPercentage = () => {
    const completedCount = subtasks.filter((subtask) => subtask.completed).length;
    return subtasks.length ? (completedCount / subtasks.length) * 100 : 0;
  };

  const handleSave = async () => {
    if (!taskName.trim()) {
      setTaskNameError(true);
      return;
    } else {
      setTaskNameError(false);
    }

    const currentDate = new Date();
    
    // Only set cardCreationDate if this is a new card or a duplicate
    const cardCreationDate = (!initialData || initialData.isDuplicate) ? currentDate.toISOString() : initialData.cardCreationDate;

    // Always update cardUpdatedOn when saving changes
    const newUpdatedOn = currentDate.toISOString();

    // Get current user's name from session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'));
    const currentUserName = userData?.userName || currentUserInfo?.displayName || 'Unknown User';

    // Create the card data object
    const cardData = {
      taskName,
      description,
      cardStatus,
      assigneeName,
      assigneeEmail,
      dueDate,
      priority,
      subtasks,
      estimate,
      cardType,
      acceptanceCriteria,
      comments,
      boardId: selectedBoardId,
      assignedSprints,
      projectId,
      tenantId,
      cardProjectName: prjName,
      cardCreatedByUserId: (initialData && !initialData.isDuplicate) ? initialData.cardCreatedByUserId : userId,
      cardCreationDate,
      assignDate: cardCreationDate,
      cardUpdatedByUserId: userId,
      cardUpdatedOn: newUpdatedOn,
      files: uploadedFiles,
      order: (initialData && !initialData.isDuplicate) ? initialData.order : 999,
      createdAt: currentDate.toLocaleString(),
      updatedAt: currentDate.toLocaleString()
    };

    try {
      if (initialData && !initialData.isDuplicate) {
        // Update existing card - handle both old and new storage systems
        const db = getFirestore(app);
        
        try {
          // First, try to update using cardId as document ID (new system)
          const cardRef = doc(db, "cards", initialData.cardId);
          await updateDoc(cardRef, {
            ...cardData,
            cardId: initialData.cardId, // Keep the original card ID
            cardUpdatedByUserId: userId,
            cardUpdatedOn: newUpdatedOn,
            updatedAt: currentDate.toISOString(),
          });
          console.log("Card updated successfully using new system");
        } catch (updateError) {
          // If that fails, search for the card by cardId field (old system)
          console.log("New system update failed, trying old system:", updateError.message);
          
          const cardsQuery = query(
            collection(db, "cards"), 
            where("cardId", "==", initialData.cardId),
            where("tenantId", "==", tenantId)
          );
          const cardsSnapshot = await getDocs(cardsQuery);
          
          if (cardsSnapshot.empty) {
            throw new Error(`Card with ID ${initialData.cardId} not found in database`);
          }
          
          // Update using the actual document ID
          const cardDoc = cardsSnapshot.docs[0];
          const cardRef = doc(db, "cards", cardDoc.id);
          await updateDoc(cardRef, {
            ...cardData,
            cardId: initialData.cardId, // Keep the original card ID
            cardUpdatedByUserId: userId,
            cardUpdatedOn: newUpdatedOn,
            updatedAt: currentDate.toISOString(),
          });
          console.log("Card updated successfully using old system with document ID:", cardDoc.id);
        }
      } else {
        // Create new card with Firestore transaction-safe counter
        const newCardId = await saveNewCard(projectId, prjName, cardData);
        cardData.cardId = newCardId;
        console.log("New card created successfully with ID:", newCardId);
      }
    } catch (error) {
      console.error("Error saving card:", error);
      console.error("Error details:", {
        message: error.message,
        code: error.code,
        stack: error.stack
      });
      alert(`Failed to save card. Error: ${error.message}. Please try again.`);
      return;
    }

    // Debug log
    console.log("Card data being saved:", cardData);
    console.log("Required fields check:", {
      hasTaskName: !!cardData.taskName,
      hasCardStatus: !!cardData.cardStatus,
      hasCardId: !!cardData.cardId,
      hasBoardId: !!cardData.boardId,
      hasProjectId: !!cardData.projectId,
      hasTenantId: !!cardData.tenantId,
      hasCardCreationDate: !!cardData.cardCreationDate,
      hasCardUpdatedOn: !!cardData.cardUpdatedOn
    });

    // Close dialog - parent component will handle refreshing the data
    onClose();
  };

  const truncateSubtaskName = (name) => {
    return name.length > 50 ? `${name.substring(0, 50)}...` : name;
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    
    // Check if adding these files would exceed the limit
    if (uploadedFiles.length + files.length > MAX_FILE_COUNT) {
      alert(`Cannot upload ${files.length} files. You can only upload up to ${MAX_FILE_COUNT} files total. Currently ${uploadedFiles.length} files uploaded.`);
      return;
    }
    
    files.forEach(file => uploadFile(file));
  };

  const uploadFile = async (file) => {
    // Check if file size exceeds limit from environment variable
    if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
      alert(`File size must be less than ${MAX_FILE_SIZE_MB}MB`);
      return;
    }

    // Check if maximum file count is reached (subtract 1 to account for zero-based indexing)
    if (uploadedFiles.length >= MAX_FILE_COUNT) {
      alert(`Maximum number of files (${MAX_FILE_COUNT}) reached. Please delete some files before uploading more.`);
      return;
    }

    try {
      // Generate unique file ID and sanitize filename
      const fileId = uuidv4();
      const sanitizedFileName = file.name.replace(/[^a-zA-Z0-9.]/g, '_');
      const filePath = `card-images/${fileId}_${sanitizedFileName}`;
      
      // Create reference to file in Firebase Storage
      const fileRef = ref(storage, filePath);
      
      // Upload file with progress tracking
      const uploadTask = uploadBytesResumable(fileRef, file);
      
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          // Update progress state
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadProgress(prev => ({
            ...prev,
            [fileId]: progress
          }));
        },
        (error) => {
          console.error('Upload error:', error);
          alert('Error uploading file. Please try again.');
        },
        async () => {
          // Check again before adding to state to prevent race conditions
          if (uploadedFiles.length >= MAX_FILE_COUNT) {
            alert(`Maximum number of files (${MAX_FILE_COUNT}) reached. The upload will be discarded.`);
            // Delete the uploaded file from storage since we can't add it
            await deleteObject(fileRef);
            return;
          }

          // Get download URL after successful upload
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          
          // Add file to local state
          setUploadedFiles(prev => {
            // One final check before adding to state
            if (prev.length >= MAX_FILE_COUNT) {
              alert(`Maximum number of files (${MAX_FILE_COUNT}) reached. The upload will be discarded.`);
              // Delete the uploaded file from storage since we can't add it
              deleteObject(fileRef);
              return prev;
            }
            return [...prev, {
              id: fileId,
              name: file.name,
              url: downloadURL,
              uploadedAt: new Date().toISOString()
            }];
          });
          
          // Clear progress state
          setUploadProgress(prev => {
            const newProgress = { ...prev };
            delete newProgress[fileId];
            return newProgress;
          });
        }
      );
    } catch (error) {
      console.error('Upload error:', error);
      alert('Error uploading file. Please try again.');
    }
  };

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    
    // Check if adding these files would exceed the limit
    if (uploadedFiles.length + files.length > MAX_FILE_COUNT) {
      alert(`Cannot upload ${files.length} files. You can only upload up to ${MAX_FILE_COUNT} files total. Currently ${uploadedFiles.length} files uploaded.`);
      return;
    }

    files.forEach(file => uploadFile(file));
    // Clear the input value to allow uploading the same file again if needed
    event.target.value = '';
  };

  const handleDeleteFile = async (fileId) => {
    const confirmed = window.confirm('Are you sure you want to delete this file?');
    if (!confirmed) return;

    try {
      // Create reference to file in Firebase Storage
      const fileRef = ref(storage, `card-images/${fileId}`);
      await deleteObject(fileRef);
      
      // Update local state by removing the deleted file
      setUploadedFiles(prev => prev.filter(file => file.id !== fileId));
    } catch (error) {
      console.error("Error deleting file:", error);
      alert('Error deleting file. Please try again.');
    }
  };

  /**
   * Comment Management Section
   * Recent changes:
   * - Removed name-related fields
   * - Using email for user identification
   * - Simplified user information handling
   */
  const handleCommentAdd = (comment) => {
    const newComment = {
      id: Date.now().toString(),
      text: typeof comment === 'object' ? comment.text : comment,
      authorId: currentUserInfo?.uid,
      authorEmail: currentUserInfo?.email,
      timestamp: new Date().toISOString(),
      isEdited: false
    };
    setComments(prevComments => [...prevComments, newComment]);
  };

  /**
   * Handles editing an existing comment
   */
  const handleCommentEdit = (commentId, updatedComment) => {
    if (!currentUserInfo) {
      console.error('User must be logged in to edit comments');
      return;
    }

    setComments(prevComments => prevComments.map(comment => {
      if (comment.id === commentId) {
        if (comment.isDeleted) {
          console.error('Deleted comments cannot be edited');
          return comment;
        }
        
        if (comment.authorId !== currentUserInfo.uid) {
          console.error('You can only edit your own comments');
          return comment;
        }
        
        return {
          ...comment,
          text: updatedComment.text,
          timestamp: updatedComment.timestamp,
          isEdited: true,
          editedAt: updatedComment.timestamp,
          editedBy: {
            id: currentUserInfo.uid,
            email: currentUserInfo?.email
          }
        };
      }
      return comment;
    }));
  };

  /**
   * Handles comment deletion
   */
  const handleCommentDelete = (commentId, shouldDeleteCompletely) => {
    if (!currentUserInfo) {
      console.error('User must be logged in to delete comments');
      return;
    }

    const commentToDelete = comments.find(comment => comment.id === commentId);
    if (!commentToDelete) {
      console.error('Comment not found');
      return;
    }

    if (commentToDelete.authorId !== currentUserInfo.uid) {
      console.error('You can only delete your own comments');
      return;
    }

    if (shouldDeleteCompletely) {
      // Completely remove the comment from the array
      setComments(prevComments => prevComments.filter(comment => comment.id !== commentId));
    } else {
      // Mark the comment as deleted
      setComments(prevComments => prevComments.map(comment => 
        comment.id === commentId 
          ? { ...comment, isDeleted: true }
          : comment
      ));
    }
  };

  const handleSubtaskExpand = (subtaskId) => {
    setExpandedSubtasks(prev => {
      const newSet = new Set(prev);
      if (newSet.has(subtaskId)) {
        newSet.delete(subtaskId);
      } else {
        newSet.add(subtaskId);
      }
      return newSet;
    });
  };

  const handleSelectFile = (fileId) => {
    setSelectedFilesToDelete(prev => {
      const newSet = new Set(prev);
      if (newSet.has(fileId)) {
        newSet.delete(fileId);
      } else {
        newSet.add(fileId);
      }
      return newSet;
    });
  };

  const handleSelectAllFiles = () => {
    if (selectedFilesToDelete.size === uploadedFiles.length) {
      // If all files are selected, deselect all
      setSelectedFilesToDelete(new Set());
    } else {
      // Select all files by creating a Set of all file IDs
      setSelectedFilesToDelete(new Set(uploadedFiles.map(file => file.id)));
    }
  };

  const handleDeleteSelectedFiles = async () => {
    if (selectedFilesToDelete.size === 0) return;

    // Show confirmation dialog before deletion
    const confirmed = window.confirm(`Are you sure you want to delete ${selectedFilesToDelete.size} selected file(s)?`);
    if (!confirmed) return;

    try {
      const updatedFiles = [...uploadedFiles];
      const deletedFiles = [];

      // Process each selected file for deletion
      for (const fileId of selectedFilesToDelete) {
        const fileIndex = updatedFiles.findIndex(f => f.id === fileId);
        if (fileIndex === -1) continue;

        try {
          // Find the file in the uploadedFiles array to get the correct path
          const fileToDelete = uploadedFiles.find(f => f.id === fileId);
          if (!fileToDelete) continue;

          // Extract the file path from the URL
          const url = new URL(fileToDelete.url);
          const filePath = decodeURIComponent(url.pathname.split('/o/')[1]);
          
          // Create reference to file in Firebase Storage
          const fileRef = ref(storage, filePath);
          
          try {
            // Try to delete the file from storage
            await deleteObject(fileRef);
            console.log(`Successfully deleted file: ${filePath}`);
          } catch (storageError) {
           
          }
          
          deletedFiles.push(fileIndex);
        } catch (error) {
          
          // Continue with other files even if one fails
        }
      }

      // Remove deleted files from the array (in reverse order to maintain indices)
      deletedFiles.sort((a, b) => b - a).forEach(index => {
        updatedFiles.splice(index, 1);
      });

      // Update Firestore document with the new files array
      if (cardId) {
        try {
          const cardRef = doc(db, "cards", cardId);
          const cardDoc = await getDoc(cardRef);
          
          if (cardDoc.exists()) {
            await updateDoc(cardRef, {
              files: updatedFiles,
              cardUpdatedByUserId: userId,
              cardUpdatedOn: new Date().toLocaleString("en-IN", {
                timeZone: "Asia/Kolkata",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
            });
            console.log("Successfully updated Firestore document");
          } else {
            console.error("Card document not found in Firestore");
          }
        } catch (firestoreError) {
          console.error("Error updating Firestore:", firestoreError);
          // Continue with local state update even if Firestore update fails
        }
      }

      // Update local state and clear selection
      setUploadedFiles(updatedFiles);
      setSelectedFilesToDelete(new Set());
    } catch (error) {
      console.error("Error in file deletion process:", error);
      alert('Error deleting files. Please try again.');
    }
  };

  const handleAssigneeChange = (e) => {
    const selectedName = e.target.value;
    setAssigneeName(selectedName);
    const user = userList.find(u => u.userName === selectedName);
    setAssigneeEmail(user ? user.email : '');
  };
//Defined constands which display the card creation and updated date in local format
const localCreationDate = cardCreationDateDisplay
  ? new Date(cardCreationDateDisplay).toLocaleString()
  : 'Unknown Date';

const localUpdatedDate = cardUpdatedOn
  ? new Date(cardUpdatedOn).toLocaleString()
  : 'Unknown Date';

  return (
    <Dialog
  open={open}
  // Only allow onClose if not triggered by backdrop click or Escape
  onClose={(event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      onClose();
    }
  }}
  maxWidth="md"
  fullWidth
  disableEscapeKeyDown
  PaperProps={{
    sx: {
      height: {
        xs: '100vh',
        sm: '90vh'
      },
      maxHeight: {
        xs: '100vh',
        sm: '90vh'
      },
      margin: {
        xs: 0,
        sm: 2
      },
      display: 'flex',
      flexDirection: 'column'
    }
  }}
>

      <Box
        sx={{
          background: 'linear-gradient(45deg, #1e88e5 30%, #66bb6a 90%)',
          color: '#fff',
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        <DialogTitle sx={{ color: 'white', fontWeight: 'bold', fontSize: '1.25rem' }}>
          {(initialData && !initialData.isDuplicate) ? 'Edit Card' : 'Add Card'}
        </DialogTitle>
      </Box>

      <DialogContent>
        <Grid container spacing={2}>
          {/* Card ID */}
          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Card ID"
              fullWidth
              variant="outlined"
              value={cardId}
              disabled
              InputProps={{ style: { backgroundColor: '#f5f5f5' } }}
            />
          </Grid>

          {/* Task Name */}
          {cardStatus !== 'Withdrawn' && (
          <Grid item xs={12}>
            <TextField
              autoFocus
              margin="dense"
              label="Summary"
              fullWidth
              variant="outlined"
              value={taskName}
              onChange={(e) => setTaskName(e.target.value.slice(0, 100))}
              error={taskNameError}
              helperText={taskNameError ? 'Task Name is required' : `${taskName.length}/100`}
              inputProps={{ maxLength: 100 }}
            />
          </Grid>
          )}

          {/* Card Status */}
          <Grid item xs={12}>
          <FormControl fullWidth variant="outlined" margin="dense">
            <InputLabel shrink={true} id="card-status-label">Card Status</InputLabel>
            <Select
              labelId="card-status-label"
              value={cardStatus}
              onChange={(e) => setCardStatus(e.target.value)}
              label="Card Status"
            >
              {columns.map((column) => (
                <MenuItem key={column.id} value={column.name}>
                  {column.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          </Grid>

          {/* Due Date */}
          {cardStatus !== 'Withdrawn' && (
          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Due Date"
              type="date"
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
              inputProps={{
                min: new Date().toISOString().split("T")[0] // Set min to today's date
              }}
            />
          </Grid>
          )}

          {/* Type */}
          {cardStatus !== 'Withdrawn' && (
          <Grid item xs={12}>
            <FormControl fullWidth margin="normal">
              <InputLabel shrink={true} id="card-type-label">Card Type</InputLabel>
              <Select
                labelId="card-type-label"
                value={cardType}
                onChange={(e) => setCardType(e.target.value)}
                label="Card Type"
              >
                <MenuItem value="Activity">Activity</MenuItem>
                <MenuItem value="Defect">Defect</MenuItem>
                <MenuItem value="Story">Story</MenuItem>
                <MenuItem value="Task">Task</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          )}

          {/* Priority */}
          {cardStatus !== 'Withdrawn' && (
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" margin="dense">
              <InputLabel shrink={true} id="priority-label">Priority</InputLabel>
              <Select
                labelId="priority-label"
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                label="Priority"
              >
                <MenuItem value="Low">Low</MenuItem>
                <MenuItem value="Medium">Medium</MenuItem>
                <MenuItem value="High">High</MenuItem>
                <MenuItem value="Urgent">Urgent</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          )}

          {/* Description */}
          {cardStatus !== 'Withdrawn' && (
          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Description"
              fullWidth
              variant="outlined"
              multiline
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value.slice(0, 500))}
              helperText={`${description.length}/500`}
              inputProps={{ maxLength: 500 }}
            />
          </Grid>
          )}

          {/* Acceptance Criteria */}
          {cardStatus !== 'Withdrawn' && (
          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Acceptance Criteria"
              fullWidth
              variant="outlined"
              multiline
              rows={4}
              value={acceptanceCriteria}
              onChange={(e) => setAcceptanceCriteria(e.target.value.slice(0,500))}
              helperText={`${acceptanceCriteria.length}/500`}
               inputProps={{ maxLength: 500 }}
            />
          </Grid>
          )}

          {/* Estimate */}
          {cardStatus !== 'Withdrawn' && (
          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Estimate "
              fullWidth
              variant="outlined"
              type="number"  // Set input type to number
              value={estimate}
              onChange={(e) => {
                const value = e.target.value;
                // Update state only if the value is a valid number or empty
                if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
                  setEstimate(value);
                }
              }}
              inputProps={{ min: 0 }} // Optional: Set minimum value to 0
            />
          </Grid>
          )}

          {/* Assignee Name */}
          {cardStatus !== 'Withdrawn' && (
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" margin="dense">
            <InputLabel shrink={true} id="assignee-name-label">Assignee Name</InputLabel>
            {/* For Assignee Name, added numerical then alphabetical based sorting */}
              <Select
              labelId="assignee-name-label"
              value={assigneeName}
              onChange={handleAssigneeChange}
              label="Assignee Name"
            >
              {[...userList]
                .sort((a, b) => {
                  const nameA = a.userName;
                  const nameB = b.userName;
                  const numA = parseInt(nameA, 10);
                  const numB = parseInt(nameB, 10);
                  
                  //if both are numbers
                  if (!isNaN(numA) && !isNaN(numB)) {
                    return numA - numB;
                  }
                  //if 1 is number and 1 is string
                  if (!isNaN(numA)) return -1;
                  if (!isNaN(numB)) return 1;

                  return nameA.localeCompare(nameB);
                })
                .map((user) => (
                  <MenuItem key={user.id} value={user.userName}>
                    {user.userName}
                  </MenuItem>
                ))}


            </Select> 

            </FormControl>
          </Grid>
          )}

          {/* Sprint name */}
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" margin="dense">
              <InputLabel id="assigned-sprints-label">Assigned Sprints</InputLabel>
              <Select
                labelId="assigned-sprints-label"
                multiple
                value={assignedSprints.map(s => s.boardId)}
                onChange={e => {
                  // Map selected sprint IDs to sprint objects
                  const selectedIds = e.target.value;
                  const selectedSprints = availableSprints
                    .filter(s => selectedIds.includes(s.boardId))
                    .map(s => ({
                      boardId: s.boardId,
                      boardName: s.boardName,
                      boardActiveStatus: s.boardActiveStatus
                    }));
                  setAssignedSprints(selectedSprints);
                }}
                renderValue={selected => availableSprints
                  .filter(s => selected.includes(s.boardId))
                  .map(s => s.boardName)
                  .join(', ')
                }
                label="Assigned Sprints"
              >
                {availableSprints.map(sprint => (
                  <MenuItem key={sprint.boardId} value={sprint.boardId}>
                    <Checkbox checked={assignedSprints.some(as => as.boardId?.trim() === sprint.boardId?.trim())} />
                    <ListItemText primary={sprint.boardName} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Board Reassignment */}
          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined" margin="dense">
              <InputLabel id="board-select-label">Select Board</InputLabel>
                  <Select
                    labelId="board-select-label"
                    value={selectedBoardId}
                    onChange={(e) => setSelectedBoardId(e.target.value)}
                  >
                    {/* <MenuItem value="ALL_BOARDS">All Boards</MenuItem> */}
                    {boards.map((board) => (
                      <MenuItem key={board.id} value={board.id}>
                        {board.boardName.length > 15 ? board.boardName.substring(0, 15) + '...' : board.boardName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
          </Grid>

          {/* Subtasks Section */}
          {cardStatus !== 'Withdrawn' && (
          <Grid item xs={12}>
            <Box sx={{ 
              mt: { xs: 2, sm: 4 },
              pt: { xs: 1, sm: 2 },
              backgroundColor: '#fafafa',
              borderRadius: 1,
              px: { xs: 1, sm: 2 }
            }}>
              <Typography variant="subtitle1" sx={{ mb: 2 }}>Subtasks</Typography>
              <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Add a subtask"
                  value={subtaskName}
                  onChange={(e) => setSubtaskName(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleAddSubtask();
                    }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1,
                    }
                  }}
                />
                <Button
                  variant="contained"
                  onClick={handleAddSubtask}
                  disabled={!subtaskName.trim()}
                  sx={{ 
                    minWidth: 'auto', 
                    px: 2,
                    bgcolor: '#4e54c8',
                    '&:hover': {
                      bgcolor: '#3f44a0'
                    }
                  }}
                >
                  <AddIcon />
                </Button>
              </Box>
              <List sx={{ 
                maxHeight: 300, 
                overflow: 'auto',
                '& .MuiListItem-root': {
                  px: 2,
                  py: 1,
                  '&:hover': {
                    bgcolor: 'rgba(0, 0, 0, 0.02)'
                  }
                }
              }}>
                {subtasks.map((subtask, index) => (
                  <ListItem
                    key={index}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      borderBottom: '1px solid #eee'
                    }}
                  >
                    <Checkbox
                      checked={subtask.completed}
                      onChange={() => handleSubtaskCompletion(subtask.id)}
                      size="small"
                      sx={{ 
                        color: '#4e54c8',
                        '&.Mui-checked': {
                          color: '#4e54c8',
                        }
                      }}
                    />
                    <ListItemText
                      primary={
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography
                            sx={{
                              textDecoration: subtask.completed ? 'line-through' : 'none',
                              color: subtask.completed ? 'text.secondary' : 'text.primary',
                              flex: 1,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            {expandedSubtasks.has(subtask.id) ? subtask.name : truncateSubtaskName(subtask.name)}
                          </Typography>
                          {subtask.name.length > 50 && (
                            <Button
                              size="small"
                              onClick={() => handleSubtaskExpand(subtask.id)}
                              sx={{ 
                                minWidth: 'auto', 
                                p: 0.5,
                                color: '#4e54c8',
                                '&:hover': {
                                  backgroundColor: 'rgba(78, 84, 200, 0.04)',
                                }
                              }}
                            >
                              {expandedSubtasks.has(subtask.id) ? 'View Less' : 'View More'}
                            </Button>
                          )}
                        </Box>
                      }
                    />
                    <IconButton
                      size="small"
                      onClick={() => handleRemoveSubtask(subtask.id)}
                      sx={{ 
                        p: 0.5,
                        color: '#d32f2f',
                        '&:hover': {
                          backgroundColor: 'rgba(211, 47, 47, 0.04)',
                        }
                      }}
                    >
                      <DeleteIcon sx={{ fontSize: 16 }} />
                    </IconButton>
                  </ListItem>
                ))}
              </List>
              <LinearProgress
                variant="determinate"
                value={calculateCompletionPercentage()}
              />
              <Typography variant="body2" sx={{ mb: 2 }}>
                {Math.round(calculateCompletionPercentage())}% Completed
              </Typography>
            </Box>
          </Grid>
          )}

          {/* File Upload Section */}
          {cardStatus !== 'Withdrawn' && (
          <Grid item xs={12} sx={{ mt: { xs: 2, sm: 4 } }}>
            <Box sx={{ 
              pt: { xs: 1, sm: 2 },
              backgroundColor: '#fafafa',
              borderRadius: 1,
              px: { xs: 1, sm: 2 }
            }}>
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                mb: 2
              }}>
                <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center' }}>
                  <AttachFileIcon sx={{ mr: 1 }} />
                  Attachments
                </Typography>
              </Box>

              {/* Drag and Drop Area */}
              <Box
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
                sx={{
                  border: `2px dashed ${isDragging ? '#4e54c8' : '#e0e0e0'}`,
                  borderRadius: 1,
                  p: 2,
                  textAlign: 'center',
                  bgcolor: isDragging ? 'rgba(78, 84, 200, 0.04)' : 'transparent',
                  transition: 'all 0.2s ease',
                  cursor: 'pointer',
                  '&:hover': {
                    borderColor: '#4e54c8',
                    bgcolor: 'rgba(78, 84, 200, 0.04)'
                  }
                }}
                onClick={() => document.getElementById('file-upload').click()}
              >
                <input
                  type="file"
                  id="file-upload"
                  multiple
                  style={{ display: 'none' }}
                  onChange={handleFileUpload}
                />
                
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                  <AttachFileIcon sx={{ fontSize: 40, color: '#4e54c8' }} />
                  <Typography variant="body2" color="textSecondary">
                    Drag and drop files here or click to upload
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {uploadedFiles.length}/{MAX_FILE_COUNT} files
                  </Typography>
                  <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mb: 1 }}>
                    Max file size can be {MAX_FILE_SIZE_MB} mb.
                  </Typography>
                </Box>
              </Box>

              {/* File List with Progress Bars */}
              {uploadedFiles.length > 0 && (
                <>
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    mb: 1,
                    mt: 2
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Checkbox
                          checked={selectedFilesToDelete.size === uploadedFiles.length}
                          indeterminate={selectedFilesToDelete.size > 0 && selectedFilesToDelete.size < uploadedFiles.length}
                          onChange={handleSelectAllFiles}
                          size="small"
                        />
                        <Typography variant="subtitle2">
                          Select All
                        </Typography>
                      </Box>
                      <Typography variant="subtitle2" color="textSecondary">
                        ({selectedFilesToDelete.size} selected)
                      </Typography>
                    </Box>
                    {selectedFilesToDelete.size > 0 && (
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={handleDeleteSelectedFiles}
                        startIcon={<DeleteIcon />}
                      >
                        Delete Selected
                      </Button>
                    )}
                  </Box>
                  <List>
                    {uploadedFiles.map((file) => (
                      <ListItem
                        key={file.id}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 2,
                          p: 1,
                          borderRadius: 1,
                          bgcolor: selectedFilesToDelete.has(file.id) ? 'rgba(211, 47, 47, 0.04)' : 'transparent',
                          '&:hover': {
                            bgcolor: selectedFilesToDelete.has(file.id) ? 'rgba(211, 47, 47, 0.08)' : 'rgba(0, 0, 0, 0.04)'
                          }
                        }}
                      >
                        <Checkbox
                          checked={selectedFilesToDelete.has(file.id)}
                          onChange={() => handleSelectFile(file.id)}
                          size="small"
                        />
                        <ListItemText
                          primary={
                            <Typography
                              component="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={{ 
                                color: '#4e54c8',
                                textDecoration: 'none',
                                '&:hover': {
                                  textDecoration: 'underline'
                                }
                              }}
                            >
                              {file.name}
                            </Typography>
                          }
                          secondary={
                            <>
                              {uploadProgress[file.id] !== undefined && uploadProgress[file.id] < 100 ? (
                                <Box sx={{ width: '100%', mt: 1 }}>
                                  <LinearProgress 
                                    variant="determinate" 
                                    value={uploadProgress[file.id]} 
                                    sx={{
                                      height: 4,
                                      borderRadius: 2,
                                      backgroundColor: 'rgba(78, 84, 200, 0.1)',
                                      '& .MuiLinearProgress-bar': {
                                        backgroundColor: '#4e54c8'
                                      }
                                    }}
                                  />
                                  <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5 }}>
                                    Uploading: {Math.round(uploadProgress[file.id])}%
                                  </Typography>
                                </Box>
                              ) : (
                                <Typography variant="caption" color="textSecondary">
                                  Uploaded on {new Date(file.uploadedAt).toLocaleString()}
                                </Typography>
                              )}
                            </>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                </>
              )}
            </Box>
          </Grid>
          )}

          {/* Comments Section */}
          {cardStatus !== 'Withdrawn' && (
          <Grid item xs={12}>
            <Box sx={{ 
              mt: { xs: 2, sm: 4 },
              pt: { xs: 1, sm: 2 },
              backgroundColor: '#fafafa',
              borderRadius: 1,
              px: { xs: 1, sm: 2 }
            }}>
              <Comments
                currentUserId={currentUserInfo?.uid}
                currentUserEmail={currentUserInfo?.email}
                existingComments={comments}
                onCommentAdd={handleCommentAdd}
                onCommentEdit={handleCommentEdit}
                onCommentDelete={handleCommentDelete}
                isAuthenticated={!!currentUserInfo}
              />
            </Box>
          </Grid>
          )}
        </Grid>
      </DialogContent>

      {/* Footer */}
      <Box mt={2} sx={{ padding: 2, background: '#dcf3f6'
, }}>
        {/* Display last updated details */}
        {initialData && !initialData.isDuplicate && cardStatus !== 'Withdrawn' && (
          <Box style={{ opacity: 0.8, marginBottom: -50 }}>
            
            <Typography variant="body2" sx={{ fontSize: '0.6rem' }}>
          Created by: {createdByUserName || 'Unknown User'}
        </Typography>
        <Typography variant="body2" sx={{ fontSize: '0.6rem' }}>
          Created on: {localCreationDate || 'Unknown Date'}
        </Typography>
        <Typography variant="body2" sx={{ fontSize: '0.6rem' }}>
              Last updated by: {updatedByUserName || 'Unknown User'}
            </Typography> 
            <Typography variant="body2" sx={{ fontSize: '0.6rem' }}>
              Last updated on: {localUpdatedDate}
            </Typography>
          </Box>
        )}

        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default AddCardDialog;